import React from 'react';
import { OutlineCard } from '../../../components/Cards';
import { TiDeviceDesktop } from 'react-icons/ti';
import { FaMobileAlt } from 'react-icons/fa';
import { FiServer } from 'react-icons/fi';
import { SiMaterialdesignicons } from 'react-icons/si';

function ServiceHome(props) {
  return (
    <div id="ServiceHome" className="offset">
      <div className="service-home-description">
        <h1>What we can serve for you</h1>
      </div>
      <div className="service-home-group">
        <OutlineCard
          icon={<TiDeviceDesktop />}
          title="Web Dev"
          description="Ecomerce, Blog, Portfolio, Profile Company, CMS, Web Apps, etc."
        />
        <OutlineCard
          icon={<FaMobileAlt />}
          title="Mobile Dev"
          description="We can make mobile applications for android and ios with hybrid technology."
        />
        <OutlineCard
          icon={<FiServer />}
          title="Server Side Dev"
          description="Build from scratch, bug fixing, server side maintenance, data backup, etc."
        />
        <OutlineCard
          icon={<SiMaterialdesignicons />}
          title="UI-UX Design"
          description="Requested designs, mockups, easy-to-understand designs, redesign, etc."
        />
      </div>
    </div>
  );
}

export default ServiceHome;